import { View } from 'react-native';
import React from 'react';
import { Text } from '~/components';

interface Props {
  title: string;
  value: string;
}

const DetailRow: React.FC<Props> = ({ title, value }) => {
  return (
    <View className="flex-row items-center justify-between my-2">
      <Text className="text-sm text-gray-600 mr-4">{title}</Text>
      <Text className="text-gray-700 text-sm font-medium text-right flex-1">
        {value.trim()}
      </Text>
    </View>
  );
};

export default DetailRow;
